import { gql } from "@apollo/client";

export const GET_USER_PROFILE = gql`
  query GetUserProfile($email: String!, $universityId: uuid!) {
    users(
      where: { email: { _eq: $email }, university_id: { _eq: $universityId } }
    ) {
      fullName
      id
      onboarding_complete
      is_trainer
      onboarding_step
      profile_picture
      university_id
      isDisabled
      is_profile_rejected
      is_profile_verified
      profile_reject_reason
      resume
      is_sso_enabled
      sso_provider
      sso_relay_state_url
      sso_last_login_at
      user_role {
        id
        role {
          id
          name
        }
      }
      college_users {
        college {
          id
          name
        }
      }
      university {
        id
        name
        description
        config
        support_email
        icon
        private_config
        isJobPortal
      }
    }
  }
`;
